import {ApplicationConfig, importProvidersFrom} from '@angular/core';
import {
  NoPreloading,
  provideRouter,
  withComponentInputBinding,
  withPreloading
} from '@angular/router';
import {routes} from './app.routes';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import {provideNoopAnimations} from '@angular/platform-browser/animations';
import {bearerInterceptor} from "./Interceptors/bearer.interceptor";
import { GoogleTagManagerModule } from 'angular-google-tag-manager';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes, withComponentInputBinding(), withPreloading(NoPreloading)),
    provideHttpClient(withFetch(), withInterceptors([bearerInterceptor])),
    provideNoopAnimations(),
    importProvidersFrom(GoogleTagManagerModule.forRoot({ id: 'GTM-K79GPJXP' })) // Remplace par ton ID GTM
    

  ]
};
